<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="page_ix"></a><a id="cont"></a>CONTENTS</h1>
<p class="toc1"><a href="#/07_foreword#fore"><i>Foreword</i></a></p>
<p class="toc1"><a href="#/08_theroswell#therose"><i>The Roswell Rashomon Effect</i></a></p>
<p class="toc1"><a href="#/09_preface#pref"><i>Preface—Roswell in Perspective: Reexamining the Case in 2020</i></a></p>
<p style="text-align:center; margin-top:1.5pc"></p>
<p class="toc"><span href="#/10_chapter01#c01" title="Link target outside of Sample"><b>CHAPTER 1:</b> The Ultimate Cold Case File</span></p>
<p class="toc"><span href="#/11_chapter02#c02" title="Link target outside of Sample"><b>CHAPTER 2:</b> Roswell: The Undeniable Truths</span></p>
<p class="toc"><span href="#/12_chapter03#c03" title="Link target outside of Sample"><b>CHAPTER 3:</b> Covering Up the Story of the Millennium</span></p>
<p class="toc"><span href="#/13_chapter04#c04" title="Link target outside of Sample"><b>CHAPTER 4:</b> Due Process Be Damned</span></p>
<p class="toc"><span href="#/14_chapter05#c05" title="Link target outside of Sample"><b>CHAPTER 5:</b> First Amendment Violations</span></p>
<p class="toc"><span href="#/15_chapter06#c06" title="Link target outside of Sample"><b>CHAPTER 6:</b> Threats of Leavenworth</span></p>
<p class="toc"><span href="#/16_chapter07#c07" title="Link target outside of Sample"><b>CHAPTER 7:</b> The Evidence Is Secured Away from Roswell</span></p>
<p class="toc"><span href="#/17_chapter08#c08" title="Link target outside of Sample"><b>CHAPTER 8:</b> Flailing in the Dark: The Officers Take Charge</span></p>
<p class="toc"><span href="#/18_chapter09#c09" title="Link target outside of Sample"><b>CHAPTER 9:</b> Searching for the On Button</span></p>
<p class="toc2"><span href="#/19_chapter10#c10" title="Link target outside of Sample"><b>CHAPTER 10:</b> Washington Looks into Roswell . . . or Did They?</span></p>
<p class="toc2"><span href="#/20_chapter11#c11" title="Link target outside of Sample"><b>CHAPTER 11:</b> Touched by Roswell</span></p>
<p class="toc2"><span href="#/20_chapter12#c12" title="Link target outside of Sample"><b>CHAPTER 12:</b> Deathbed Confessions</span></p>
<p class="toc2"><span href="#/21_chapter13#c13" title="Link target outside of Sample"><b>CHAPTER 13:</b> When Death Is Not the Final Arbiter</span></p>
<p class="toc2"><span href="#/22_chapter14#c14" title="Link target outside of Sample"><b>CHAPTER 14:</b> In Their Own Words, the Witnesses Speak Out</span></p>
<p class="toc2"><span href="#/23_chapter15#c15" title="Link target outside of Sample"><b>CHAPTER 15:</b> The Most Important Trial of the Millennium</span></p>
<p style="text-align:center; margin-top:1.5pc"></p>
<p class="toc1"><span href="#/24_notes#note" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc1"><span href="#/25_index#inde" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_contents.vue?558e20e2